import React, { useContext } from "react";
import "../Navbar/Navbar.css";
import { Link } from "react-router-dom";
import { Context } from "../../Context/Context";

function Navbar() {
  const { user, dispatch } = useContext(Context);
  const PF = "https://mern-blog.glitch.me/images/";

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
  };

  return (
    <div className="navbar">
      <div className="navLeft">
        <a href="#" className="navLogo link">
          ZeBlogs
        </a>
      </div>
      <div className="navCenter">
        <ul className="navList">
          <li className="navListItem">
            <Link className="link" to="/">
              Home
            </Link>
          </li>

          <li className="navListItem">
            <Link className="link" to="/write">
              Write
            </Link>
          </li>
          <li className="navListItem" onClick={handleLogout}>
            {user && "Logout"}
          </li>
        </ul>
      </div>
      <div className="navRight">
        {user ? (
          <Link className="link" to="/settings">
            <img className="navImg" src={PF + user.profilePic} alt=" " />
          </Link>
        ) : (
          <ul className="navList">
            <li className="navListItem">
              <Link className="link" to="/login">
                Login
              </Link>
            </li>

            <li className="navListItem">
              <Link className="link" to="/register">
                Register
              </Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
}

export default Navbar;
